import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";

import TablePaginationAction from "../TablePaginationAction/TablePaginationAction";
import { useStyles } from "./CustomTableFooter.css";

class CustomTableFooter extends Component {
  render() {
    const { classes } = this.props;
    return (
      <TableFooter>
        <TableRow>
          {this.props.leftAlign === true ? (
            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                20,
                30,
                40,
                50,
                { label: "All", value: -1 },
              ]}
              classes={{ toolbar: classes.leftFoot }}
              count={this.props.count}
              rowsPerPage={this.props.rowsPerPage}
              page={this.props.page}
              onChangePage={this.props.onChangePage}
              onChangeRowsPerPage={this.props.onChangeRowsPerPage}
              ActionsComponent={TablePaginationAction}
            />
          ) : (
            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                20,
                30,
                40,
                50,
                { label: "All", value: -1 },
              ]}
              count={this.props.count}
              rowsPerPage={this.props.rowsPerPage}
              page={this.props.page}
              onChangePage={this.props.onChangePage}
              onChangeRowsPerPage={this.props.onChangeRowsPerPage}
              ActionsComponent={TablePaginationAction}
            />
          )}
        </TableRow>
      </TableFooter>
    );
  }
}

export default withStyles(useStyles)(CustomTableFooter);
